import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ManageElements from './ManageElements';
import ManageClusters from './ManageClusters';
import ManageQuestions from './ManageQuestions';
import ManageFeedbackQuestions from './ManageFeedbackQuestions';
import ManageRecommendations from './ManageRecommendations';
import ManageReleaseNotes from './ManageReleaseNotes';
import ManageUsersAndTeams from './ManageUsersAndTeams';
import ManageFeatureRequests from './ManageFeatureRequests';
import ManageBugReports from './ManageBugReports';
import ManageConnections from './ManageConnections';
import ManageAnnouncements from './ManageAnnouncements';
import ManageReports from './ManageReports';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLayers, FiHelpCircle, FiBookOpen, FiInfo, FiUsers, FiMessageSquare, FiAlertCircle, FiGrid, FiShare2, FiSettings, FiMessageCircle, FiBell, FiBarChart2 } = FiIcons;

const AdminDashboard = () => {
  const location = useLocation();
  // Setze 'clusters' als Standard-Tab
  const [activeTab, setActiveTab] = useState('clusters');

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const tabs = [
    { id: 'clusters', label: 'Cluster', icon: FiGrid, component: <ManageClusters /> },
    { id: 'elements', label: 'Elemente', icon: FiLayers, component: <ManageElements /> },
    { id: 'connections', label: 'Verbindungen', icon: FiShare2, component: <ManageConnections /> },
    { id: 'questions', label: 'Fragen', icon: FiHelpCircle, component: <ManageQuestions /> },
    { id: 'recommendations', label: 'Empfehlungen', icon: FiBookOpen, component: <ManageRecommendations /> },
    { id: 'feedback-questions', label: 'Team-Feedback', icon: FiMessageCircle, component: <ManageFeedbackQuestions /> },
    { id: 'users-teams', label: 'Benutzer & Teams', icon: FiUsers, component: <ManageUsersAndTeams /> },
    { id: 'reports', label: 'Reports', icon: FiBarChart2, component: <ManageReports /> },
    { id: 'release-notes', label: 'Release Notes', icon: FiInfo, component: <ManageReleaseNotes /> },
    { id: 'feature-requests', label: 'Feature Requests', icon: FiMessageSquare, component: <ManageFeatureRequests /> },
    { id: 'bug-reports', label: 'Bug Reports', icon: FiAlertCircle, component: <ManageBugReports /> },
    { id: 'announcements', label: 'Announcements', icon: FiBell, component: <ManageAnnouncements /> },
  ];

  return (
    <div className="p-6 w-full">
      <div className="mb-6 flex-shrink-0">
        <h1 className="text-2xl font-bold text-brand-dark flex items-center">
          <SafeIcon icon={FiSettings} className="w-7 h-7 mr-3 text-brand-secondary" />
          Admin Bereich
        </h1>
        <p className="text-gray-600 mt-2">
          Verwalten Sie hier die Inhalte der Anwendung.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="border-b border-gray-200">
          <nav className="flex flex-wrap -mb-px" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  group inline-flex items-center py-4 px-6 border-b-2 font-medium text-sm whitespace-nowrap transition-colors
                  ${activeTab === tab.id
                    ? 'border-brand-secondary text-brand-secondary'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                `}
              >
                <SafeIcon 
                  icon={tab.icon} 
                  className={`
                    -ml-0.5 mr-2 h-5 w-5 transition-colors
                    ${activeTab === tab.id ? 'text-brand-secondary' : 'text-gray-400 group-hover:text-gray-500'}
                  `}
                />
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="p-6">
          {tabs.find(t => t.id === activeTab)?.component}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;